import { Badge } from '@chakra-ui/react'
import formatter from 'utils/formatter'

interface Props {
    status: string
}
export const BadgeStatus: React.FC<Props> = ({ status }) => {
    return (
        <Badge
            size="xl"
            w="full"
            textAlign="center"
            colorScheme={
                ['REGISTRADO', 'CANCELADO', 'BAIXADO'].includes(status)
                    ? 'info'
                    : status === 'RECUSADO'
                    ? 'error'
                    : 'grayscale'
            }
            textTransform="initial"
            variant={status === 'PROCESSANDO' ? 'subtle' : 'solid'}
        >
            {formatter.firstLatterUppercase(status)}
        </Badge>
    )
}
